export enum EnumCmsPromotionPostViewEnum {
  INLINE = 'INLINE',
  DIALOG = 'DIALOG',
  NEW_PAGE = 'NEW_PAGE',
}

export enum EnumCmsPromotionPostIntegratedType {
  REACH_TEXT = 'REACH_TEXT',
  EXTERNAL_URL = 'EXTERNAL_URL',
  BUILDER_IO = 'BUILDER_IO',
}

export enum EnumCmsWidgetTypes {
  STORY = 'story',
  SLIDER = 'slider',
  SLIDER_ITEM = 'slider_item',
  SOCIALS_LINK = 'socials_link',
  NEWSLETTER = 'newsletter',
  GAME_REPLAYS = 'game_replay',
  POPUP = 'popup',
  STORY_GROUP = 'story_group',
  GAME_REPLAY_GROUP = 'game_replay_group',
  ACTION_GRID = 'action_grid',
  ACTION_GRID_ITEM = 'action_grid_item',
  RAF_TERMS_AND_CONDITIONS = 'raf_terms_and_conditions',
  WEBSITE_FOOTER = 'website_footer',
  MENU_WIDGET = 'menu_widget',
}

export enum EnumCmsCtaOption {
  NO_ACTION = 'noAction',
  TO_REGISTER = 'goToRegister',
  TO_LOGIN = 'goToLogin',
  TO_PROMOTION = 'goToPromotion',
  TO_PROVIDER = 'goToProvider',
  TO_EXTERNARL_URL = 'goToExternalUrl',
  TO_GAME = 'goToGame',
  TO_CATEGORY = 'goToCategory',
  TO_RACE = 'goToRace',
  TO_DEPOSIT = 'goToDeposit',
  TO_GAME_BOX = 'goToGameBox',
  TO_REF_FRIEND = 'goToRefFriend',
}

export enum EnumCmsPromotionPostTagsEnum {
  CASINO = 'CASINO',
  LIVE_CASINO = 'LIVE_CASINO',
  SPORT = 'SPORT',
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
  RACE = 'RACE',
  GOS = 'GOS',
  INSTAGRAM = 'INSTAGRAM',
}

export enum EnumCmsPageStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DRAFT = 'draft',
}

export enum EnumCmsPageTypeEnum {
  CATEGORY_PAGE = 'category_page',
  PROMO_POST = 'promotion_post',
  BLOG_ARTICLE = 'blog_article',
  HOME_PAGE = 'home_page',
  INFO_PAGE = 'info_page',
  SIGNUP_PAGE = 'signup_page',
  LOGIN_PAGE = 'login_page',
  RAFFLE_PAGE = 'raffle_draw',
}
